import React from 'react';
export const Problem = () => {
  return <section className="mb-10" data-id="element-283">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-284">
        De stille strijd die niemand ziet, maar herkenbaar is voor veel
        hondeneigenaren:
      </h2>

      <p className="mb-6 leading-relaxed" data-id="element-285">
        Linda staarde naar haar hond Oli, die angstig gromt en kort blaft zodra
        hij buiten wat hoort. Het was al de derde keer deze avond.
      </p>

      <p className="mb-6 leading-relaxed" data-id="element-286">
        Ze deed alles 'goed'. Drie wandelingen per dag. Gezond eten. Genoeg
        aandacht. Heel veel liefde.
      </p>

      <p className="mb-6 leading-relaxed" data-id="element-287">
        Toch bleef Oli angstig, onrustig, gestrest en erg reactief.
      </p>

      <p className="mb-6 leading-relaxed" data-id="element-288">
        Hij blaft zelfs naar bezoek dat hij al kent…
      </p>

      <p className="mb-6 leading-relaxed" data-id="element-289">
        Oli is een herplaatser. Een hond met een rugzakje. En sinds het begin is
        het niet beter geworden.
      </p>

      <p className="mb-6 leading-relaxed" data-id="element-290">
        Linda had alles geprobeerd. Hondenschool. Privétrainer. YouTube-video's.
        Boeken over hondengedrag. Kalmerende supplementen. Niets leek écht te
        werken.
      </p>

      <p className="mb-6 leading-relaxed" data-id="element-291">
        's Avonds ligt ze vaak wakker met dezelfde vraag:
      </p>

      <p className="mb-6 leading-relaxed font-semibold text-blue-800" data-id="element-292">
        "Waarom is hij nog steeds angstig? Waarom vertrouwt hij me nog steeds
        niet volledig? Wat doe ik verkeerd?"
      </p>

      <p className="mb-6 leading-relaxed" data-id="element-293">
        Ze voelt zich machteloos en zelfs schuldig. Want als Oli zo angstig is,
        dan moet zij toch iets fout doen?
      </p>

      <p className="mb-6 leading-relaxed italic" data-id="element-294">
        "Ik wil gewoon dat hij zich veilig voelt bij mij. Is dat te veel
        gevraagd?" Zegt Linda regelmatig tegen zichzelf…
      </p>

      <div className="w-full mb-6" data-id="element-295">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uzbnXVz3nVptg2L15twYUQ/Scherm_afbeelding_2025-08-15_om_15.32.12_(1)-min.png" alt="Innig moment tussen een vrouw en haar hond die elkaar aandachtig aankijken" className="w-full h-auto rounded-lg shadow-md" data-id="element-296" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-297">
          De diepe connectie die mogelijk is wanneer je elkaar écht begrijpt
        </p>
      </div>

      <p className="mb-6 leading-relaxed" data-id="element-298">
        Als je dit herkent — die knagende twijfel, dat gevoel van
        machteloosheid, de frustratie dat niets lijkt te werken — dan wil ik je
        iets vertellen.
      </p>

      <p className="mb-6 leading-relaxed font-semibold text-blue-800 text-lg" data-id="element-299">
        Het ligt niet aan jou. En het ligt ook niet aan je hond.
      </p>

      <p className="mb-6 leading-relaxed" data-id="element-300">Waaraan wel?</p>

      <h2 className="text-xl font-bold text-blue-800 mb-4" data-id="element-301">
        De onzichtbare muur tussen jullie, waardoor jij en je hond elkaar niet
        goed begrijpen:
      </h2>

      <p className="mb-6 leading-relaxed font-semibold" data-id="element-302">
        Het probleem is niet wat je denkt…
      </p>

      <p className="mb-6 leading-relaxed" data-id="element-303">
        Het is geen gebrek aan liefde. Geen gebrek aan inzet. Geen gebrek aan
        geduld.
      </p>

      <p className="mb-6 leading-relaxed" data-id="element-304">
        Er staat een onzichtbare muur tussen jou en je hond. Een muur die je
        niet kunt zien, maar die elke dag aanwezig is.
      </p>

      <p className="mb-6 leading-relaxed" data-id="element-305">
        Bij elke wandeling. Bij elk moment van onrust. Bij elke poging om je
        hond gerust te stellen.
      </p>

      <p className="mb-6 leading-relaxed font-semibold text-blue-800" data-id="element-306">
        Die muur is in de relatie tussen hond en baasje een taalbarrière.
      </p>

      <p className="mb-6 leading-relaxed" data-id="element-307">Je moet het zo zien:</p>

      <p className="mb-6 leading-relaxed" data-id="element-308">
        Je houdt van iemand. Je wilt niets liever dan die persoon gelukkig
        maken, maar jullie spreken een andere taal. Jij Nederlands, de ander
        Chinees.
      </p>

      <p className="mb-6 leading-relaxed" data-id="element-309">
        Jullie begrijpen elkaar in grote lijnen, want:
      </p>

      <p className="mb-6 leading-relaxed" data-id="element-310">
        Een glimlach is universeel. Een boze blik ook. Maar de nuance? De
        subtiele signalen? Die gaan verloren wanneer je niet volledig dezelfde
        taal spreekt.
      </p>

      <p className="mb-6 leading-relaxed" data-id="element-311">
        Dit heeft als gevolg dat je geen diepe vertrouwensband met elkaar kan
        opbouwen…
      </p>

      <p className="mb-6 leading-relaxed" data-id="element-312">
        Dit is precies wat er gebeurt tussen jou en je hond. Elke dag. Zonder
        dat je het doorhebt.
      </p>

      <p className="mb-6 leading-relaxed" data-id="element-313">
        Want honden spreken geen Nederlands. Zij spreken een eigen taal.
      </p>

      <p className="mb-6 leading-relaxed font-semibold text-blue-800" data-id="element-314">
        Maar wees gerust. Het is een taal die wij als hondenbaasjes kunnen
        leren…
      </p>
    </section>;
};